import React, { useEffect, useState } from "react";
import { View } from "react-native";
import commonStyles from "../../../styles/commonStyles";
import OverflowTooltipText from "../../../components/OverflowTooltipText";
import { ScrollView } from "react-native-gesture-handler";
import { statesArray } from "./statesArray";
import AppText from "../../../components/AppText";
interface AddressViewProps {
  userData: any;
}

const AddressView: React.FC<AddressViewProps> = ({ userData }) => {
  useEffect(() => {
    // console.log("User data for Address View:", userData);
  }, []);
  const toTitleCase = (str: string) =>
    str
      .toLowerCase()
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  return (
    <ScrollView>
      <View style={[commonStyles.subDetails, { paddingTop: 0 }]}>
        <AppText style={commonStyles.subTitle}>Address 1</AppText>
        <OverflowTooltipText
          text={toTitleCase(userData?.address?.street1 || "")}
          style={commonStyles.subValue}
          containerWidth="70%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Address 2</AppText>
        <OverflowTooltipText
          text={toTitleCase(userData?.address?.street2 || "")}
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>

      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>City</AppText>
        <OverflowTooltipText
          text={toTitleCase(userData?.address?.city || "")}
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>State</AppText>
        <OverflowTooltipText
          text={
            statesArray.find((state) => state.value == userData?.address?.state)
              ?.name || ""
          }
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>
      <View style={commonStyles.subDetails}>
        <AppText style={commonStyles.subTitle}>Zip Code</AppText>
        <OverflowTooltipText
          text={userData?.address?.zipCode || ""}
          style={commonStyles.subValue}
          containerWidth="60%"
        />
      </View>
    </ScrollView>
  );
};

export default AddressView;
